import type { Command } from '@blocksuite/std';
import type { BlockModel } from '@blocksuite/store';

/**
 * StreamLain trashcan integration.
 * Set at runtime by StreamLain to enable soft-delete for trashable blocks.
 */
export let streamlainTrashcanHandler:
  | ((store: unknown, model: BlockModel) => boolean)
  | null = null;

/**
 * Called by StreamLain to register the trashcan handler.
 * This avoids circular dependencies between affine-shared and affine-block-streamlain.
 */
export function registerStreamlainTrashcanHandler(
  handler: (store: unknown, model: BlockModel) => boolean
): void {
  streamlainTrashcanHandler = handler;
}

export const deleteSelectedModelsCommand: Command<{
  selectedModels?: BlockModel[];
}> = (ctx, next) => {
  const models = ctx.selectedModels;

  if (!models) {
    console.error(
      '`selectedModels` is required, you need to use `getSelectedModels` command before adding this command to the pipeline.'
    );
    return;
  }

  models.forEach(model => {
    // StreamLain: Soft-delete Database and Automation blocks (if handler registered)
    if (streamlainTrashcanHandler) {
      const handled = streamlainTrashcanHandler(ctx.std.store, model);
      if (handled) return; // Successfully moved to trashcan
    }

    ctx.std.store.deleteBlock(model);
  });

  return next();
};
